"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaneLayer = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const Constants_1 = require("../../Core/Constants");
let LaneLayer = class LaneLayer extends pixi_js_1.Container {
    constructor(resources) {
        super();
        const lane = new pixi_js_1.Sprite(resources.game.textures.rhythm_line);
        lane.anchor.set(0.5, 1);
        lane.position.set(Constants_1.CenterX, Constants_1.LaneBottomY);
        this.addChild(lane);
        const line = new pixi_js_1.Sprite(resources.game.textures.play_line);
        line.anchor.set(0.5);
        line.position.set(Constants_1.CenterX, Constants_1.LaneBottomY);
        this.addChild(line);
        // this.cacheAsBitmap = true
    }
};
LaneLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources])
], LaneLayer);
exports.LaneLayer = LaneLayer;
//# sourceMappingURL=LaneLayer.js.map